import _regenerator from "@babel/runtime/helpers/esm/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import npsService from "../../services/nps";
var state = {
  nps: null,
  npsEspecifico: null,
  carregandoNps: false,
  erroCarregarNps: false,
  registrandoResposta: false,
  erroRegistrarResposta: false
};
var mutations = {
  setNps: function setNps(state, payload) {
    state.nps = payload;
  },
  setNpsEspecifico: function setNpsEspecifico(state, payload) {
    state.npsEspecifico = payload;
  },
  setCarregandoNps: function setCarregandoNps(state, payload) {
    state.carregandoNps = payload;
  },
  setErroCarregarNps: function setErroCarregarNps(state, payload) {
    state.erroCarregarNps = payload;
  },
  setRegistrandoResposta: function setRegistrandoResposta(state, payload) {
    state.registrandoResposta = payload;
  },
  setErroRegistrarResposta: function setErroRegistrarResposta(state, payload) {
    state.erroRegistrarResposta = payload;
  }
};
var actions = {
  getNps: function getNps(_ref, params) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var commit, _yield$npsService$get, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            commit('setCarregandoNps', true);
            _context.p = 1;
            _context.n = 2;
            return npsService.getNps(params);
          case 2:
            _yield$npsService$get = _context.v;
            data = _yield$npsService$get.data;
            if (data && !(data !== null && data !== void 0 && data.resposta)) {
              commit('chat/incrementarMensagens', null, {
                root: true
              });
            }
            commit('setNps', data);
            commit('setCarregandoNps', false);
            commit('setErroCarregarNps', false);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            commit('setErroCarregarNps', true);
            commit('setCarregandoNps', false);
            console.error(_t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }))();
  },
  getNpsEspecifico: function getNpsEspecifico(_ref2, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var commit, _yield$npsService$get2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref2.commit;
            commit('setCarregandoNps', true);
            _context2.p = 1;
            _context2.n = 2;
            return npsService.getNpsEspecifico(payload);
          case 2:
            _yield$npsService$get2 = _context2.v;
            data = _yield$npsService$get2.data;
            commit('setNpsEspecifico', data);
            commit('setCarregandoNps', false);
            commit('setErroCarregarNps', false);
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            commit('setErroCarregarNps', true);
            commit('setCarregandoNps', false);
            console.error(_t2);
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }))();
  },
  registrarResposta: function registrarResposta(_ref3, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var commit, _yield$npsService$reg, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref3.commit;
            commit('setRegistrandoResposta', true);
            _context3.p = 1;
            _context3.n = 2;
            return npsService.registrarResposta(payload);
          case 2:
            _yield$npsService$reg = _context3.v;
            data = _yield$npsService$reg.data;
            commit('setRegistrandoResposta', false);
            commit('setErroRegistrarResposta', false);
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            commit('setErroRegistrarResposta', true);
            commit('setRegistrandoResposta', false);
            console.error(_t3);
          case 4:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 3]]);
    }))();
  },
  atualizarResposta: function atualizarResposta(_ref4, payload) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var commit, _yield$npsService$atu, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref4.commit;
            commit('setRegistrandoResposta', true);
            _context4.p = 1;
            _context4.n = 2;
            return npsService.atualizarResposta(payload);
          case 2:
            _yield$npsService$atu = _context4.v;
            data = _yield$npsService$atu.data;
            commit('setRegistrandoResposta', false);
            commit('setErroRegistrarResposta', false);
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            commit('setErroRegistrarResposta', true);
            commit('setRegistrandoResposta', false);
            console.error(_t4);
          case 4:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }))();
  }
};
var getters = {
  nps: function nps(state) {
    return state.nps;
  },
  npsEspecifico: function npsEspecifico(state) {
    return state.npsEspecifico;
  },
  carregandoNps: function carregandoNps(state) {
    return state.carregandoNps;
  },
  erroCarregarNps: function erroCarregarNps(state) {
    return state.erroCarregarNps;
  },
  registrandoResposta: function registrandoResposta(state) {
    return state.registrandoResposta;
  },
  erroRegistrarResposta: function erroRegistrarResposta(state) {
    return state.erroRegistrarResposta;
  }
};
export default {
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  namespaced: true
};